<template>
  <div id="settings-saas-account" class="settings-container">
    <!-- Header com botão de voltar -->
    <div class="settings-header">
      <v-btn
        icon
        small
        @click="$router.back()"
        class="back-button"
      >
        <v-icon color="grey darken-3">mdi-arrow-left</v-icon>
      </v-btn>
    </div>

    <!-- Card centralizado -->
    <v-card
      id="settings-card"
      class="settings-card"
      elevation="0"
      outlined
    >
      <v-card-title class="justify-center pt-8">
        <div class="text-center">
          <v-avatar color="purple lighten-4" size="56" class="mb-4">
            <v-icon color="purple darken-2" size="32">mdi-server-network</v-icon>
          </v-avatar>
          <div class="text-h5 font-weight-bold mt-4">Conta SaaS</div>
          <div class="text-caption grey--text mt-1">Gerenciar a conta SaaS principal do sistema</div>
        </div>
      </v-card-title>

      <v-card-text class="pa-8">
        <!-- Aviso de desenvolvimento -->
        <v-alert
          type="warning"
          text
          icon="mdi-alert"
          class="mb-6"
        >
          <strong>Em Desenvolvimento:</strong> Esta funcionalidade ainda não está conectada ao backend.
        </v-alert>

        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          class="form-container"
        >
          <div class="form-field">
            <v-text-field
              v-model="formData.name"
              label="Nome da Conta SaaS *"
              :rules="[rules.required]"
              outlined
              dense
              hint="Ex: ElevMent Enterprise"
            />
          </div>

          <div class="form-field">
            <v-select
              v-model="formData.type"
              :items="typeOptions"
              label="Tipo de Conta *"
              :rules="[rules.required]"
              outlined
              dense
            />
          </div>

          <div class="form-field">
            <v-switch
              v-model="formData.active"
              label="Conta Ativa"
              color="success"
              class="mt-0"
            />
          </div>

          <v-alert
            type="info"
            text
            dense
            class="mb-6"
          >
            ℹ️ A Conta SaaS será criada com:
            <ul class="mt-2">
              <li><strong>Nome:</strong> {{ formData.name || '(não informado)' }}</li>
              <li><strong>Tipo:</strong> {{ formData.type }}</li>
              <li><strong>Status:</strong> {{ formData.active ? 'ATIVA' : 'INATIVA' }}</li>
            </ul>
            <div class="mt-2">
              ⚠️ A conta SaaS deve ser criada <strong>primeiro</strong> para habilitar as demais funcionalidades.
            </div>
          </v-alert>

          <!-- Botões de ação centralizado -->
          <div class="button-container">
            <v-btn
              color="purple"
              rounded
              @click="createSaasAccount"
              :disabled="!valid"
              :loading="loading"
              class="action-button"
            >
              <v-icon left>mdi-content-save</v-icon>
              Criar Conta SaaS
            </v-btn>
          </div>
        </v-form>

        <!-- Painel de informações do endpoint -->
        <v-expansion-panels class="mt-6">
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon left color="purple">mdi-information</v-icon>
                <strong>Informações do Endpoint Backend</strong>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-simple-table>
                <tbody>
                  <tr>
                    <td class="font-weight-bold">Método:</td>
                    <td><v-chip small color="success">POST</v-chip></td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">URL:</td>
                    <td><code>/api/admin/bootstrap/saas-account</code></td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Descrição:</td>
                    <td>Cria a conta 'Mãe' do sistema SaaS, responsável por gerenciar tudo.</td>
                  </tr>
                </tbody>
              </v-simple-table>

              <v-divider class="my-4"></v-divider>

              <div class="font-weight-bold mb-2">Payload de exemplo:</div>
              <pre class="purple lighten-5 pa-3" style="border-radius: 4px; overflow-x: auto;">{{ JSON.stringify(formData, null, 2) }}</pre>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>

    <!-- Snackbar de feedback -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="3000"
      top
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar.show = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'SaasAccountSettings',

  data: () => ({
    valid: false,
    loading: false,

    formData: {
      name: 'ElevMent Enterprise',
      type: 'OWNER',
      active: true,
    },

    typeOptions: [
      { text: 'Owner (Dono)', value: 'OWNER' },
      { text: 'Partner (Parceiro)', value: 'PARTNER' },
    ],

    rules: {
      required: v => !!v || 'Campo obrigatório',
    },

    snackbar: {
      show: false,
      text: '',
      color: 'success',
    },
  }),

  methods: {
    async createSaasAccount() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.loading = true

      try {
        console.log(' Criar Conta SaaS:', this.formData)
        
        // Simulação de chamada ao backend (mock)
        await new Promise(resolve => setTimeout(resolve, 1000))

        this.snackbar = {
          show: true,
          text: '✅ Conta SaaS criada com sucesso! (mock)',
          color: 'success',
        }

        // Redirecionar após sucesso
        setTimeout(() => {
          this.$router.push('/settings')
        }, 2000)
      } catch (error) {
        console.error('❌ Erro:', error)
        this.snackbar = {
          show: true,
          text: 'Erro ao criar conta SaaS',
          color: 'error',
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
/* Container principal - estilo macOS */
#settings-saas-account {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  background: linear-gradient(135deg, #F5F5F7 0%, #f0f2f5 100%);
}

.theme--dark #settings-saas-account {
  background: linear-gradient(135deg, #121212 0%, #1C1C1E 100%);
}

/* Header com botão de voltar */
.settings-header {
  position: fixed;
  top: 1rem;
  left: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  z-index: 100;
}

.back-button {
  transition: all 0.2s ease;
}

.back-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.theme--dark .back-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Card centralizado - estilo macOS */
.settings-card {
  width: 100%;
  max-width: 500px;
  border-radius: 20px !important;
  background: white !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
}

.theme--dark .settings-card {
  background: #1C1C1E !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
}

/* Form container */
.form-container {
  width: 100%;
}

.form-field {
  margin-bottom: 1.5rem;
}

.form-field:last-of-type {
  margin-bottom: 0;
}

/* Button container centralizado */
.button-container {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.action-button {
  min-width: 200px;
}

/* Code styling */
code {
  background-color: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  font-size: 0.85em;
}

.theme--dark code {
  background-color: rgba(255, 255, 255, 0.1);
  color: #e8e8e8;
}

pre {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  border-radius: 8px;
  overflow-x: auto;
}

/* Responsive */
@media (max-width: 600px) {
  #settings-saas-account {
    padding: 0.5rem;
  }

  .settings-card {
    max-width: 100%;
    border-radius: 16px !important;
  }

  .settings-header {
    position: static;
    margin-bottom: 2rem;
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
